<template>
  <section class="new-index" :class="{ 'hide-car-btn': !truckChannelData.showCarBtn }">
    <div class="detail-B">
      <div class="header">
        <div class="header-banner" :class="{ 'long-screen' : mixinData.pageScale > 1.8  }">
          <div class="channel-logo" v-if="truckChannelData.logo">
            <div class="l flex-1">
              <img lazy-load mode="widthFix" :src="truckChannelData.logo" />
            </div>
            <img class="close" lazy-load mode="widthFix" src="https://wecos.etczs.net/h5/truck/truck-logo-close.png" />
            <div class="r flex-1">
              <img  lazy-load mode="widthFix" src="https://wecos.etczs.net/h5/truck/etc-logo-2021.png" />
            </div>
          </div>
          <img class="header-img" lazy-load mode="widthFix" src="https://wecos.etczs.net/pages/truck/truck-header-banner-new01.png" />
          <div class="header-tip">
            <div class="swiper">
              <transition name="apply" >
                <div class="item-box" :key="applyIndex">
                  <div class="swipe-img">
                    <img :src="currentApply.img || 'https://wecos.etczs.net/assets/images/etc-logo.jpg'" />
                  </div>
                  <div class="item">{{currentApply.msg}}</div>
                </div>
              </transition>

            </div>
          </div>
          <div class="btns-con">
            <div class="etc-introduce">
              <div class="introduce-l">
                <div class="title">
                  <div class="name">货车ETC</div>
                  <div class="logo">
                    <img class="logo-img" mode="widthFix" src="https://wecos.etczs.net/pages/truck/wxPay-logo-A06D3D.png" />
                    <div class="logo-text">微信支付</div>
                  </div>
                </div>
                <div class="tip">一年劲省过路费<span>5000元</span></div>
              </div>
              <div class="introduce-r">
                <img class="" src="https://wecos.etczs.net/pages/truck/truckDetail-B-OBU.png" />
                <div class="text">- 产品以实物为准 -</div>
              </div>
            </div>
            <div class="privilege">
              <div class="li"><div class="num">1.</div><div class="label">设备免费：</div><div class="value">赠送ETC卡+设备</div></div>
              <div class="li"><div class="num">2.</div><div class="label">保障服务：</div><div class="value">2年质保</div></div>
              <div class="li"><div class="num">3.</div><div class="label">附赠权益：</div><div class="value">违章提醒、路费开票提醒</div></div>
            </div>
            <div ref="allBtn" class="btn-con">
              <button class="apply-btn" type="light" @click="buttonHandler" >
                办理货车ETC
                <img class="truck-btn-tip" lazy-load mode="widthFix" src="https://wecos.etczs.net/pages/truck/truck-btn-tip.png" />
              </button>
              <div class="car-entry" @click="navigateToPage">
                <img class="icon" src="https://wecos.etczs.net/newIndex/etc-car.png" />
                <span class="text">前往办理乘用车ETC</span>
                <img class="icon-right" src="https://wecos.etczs.net/apply/icon-right.png" />
              </div>

            </div>
          </div>
        </div>
        <div class="evaluate truck-item" >
          <div class="title">看看司机朋友怎么说：</div>
          <div class="evaluate-list" >
            <transition name="evaluate" >
              <div class="evaluate-item"  :key="evaluateIndex">
                <img class="evaluate-item-l" :src="currentEvaluate.avatar" />
                <div class="evaluate-item-r">
                  <div class="name">{{ currentEvaluate.title }}</div>
                  <div class="value">{{ currentEvaluate.content }}</div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="discount truck-item">
          <div class="truck-field-title-flex ">
            <div class="l">
              <div class="t">全国高速95折</div>
              <div class="b">部分优惠省份低至85折</div>

            </div>
            <div class="r">
              <img lazy-load src="https://wecos.etczs.net/pages/truck/five-heart.png" />
              <div class="b">为3千万货车司机降路费</div>

            </div>
          </div>
          <div class="discount-table">
            <div class="l table-item">
              <div class="table-title">
                <img lazy-load mode="widthFix" src="https://wecos.etczs.net/pages/truck/truck-detail-table-icon-01.png" />
                <span>省份</span>
              </div>
              <div>江苏</div>
              <div>山东</div>
              <!-- <div class="height">贵州</div> -->
              <div>广西</div>
              <div>其他</div>
            </div>
            <div class="r table-item">
              <div class="table-title">
                <img lazy-load mode="widthFix" src="https://wecos.etczs.net/pages/truck/truck-detail-table-icon-02.png" />
                <span>ETC优惠标准</span>
              </div>
              <div>江苏运政车办理ETC省内享<span class="yellow">85折</span></div>
              <div>ETC货车均享省内<span class="yellow">85折</span></div>
              <!-- <div class="height">ETC货车均享省内<span class="yellow">95折</span>，ETC集装箱叠加<span class="yellow">7折</span>优惠，4轴货车叠加<span class="yellow">3.6折</span>优惠</div> -->
              <div>二类至五类ETC货车均享省内<span class="yellow">85折</span></div>
              <div>ETC普惠<span class="yellow">95折</span></div>
            </div>
          </div>
          <div class="tip">- 标准取自各省公开文件，仅供参考，如有疑问请咨询各省交通部门 -</div>
        </div>
        <div class="advantage truck-item">
          <div class="truck-field-title-flex ">
            <div class="l">
              <div class="t">包邮快递到家</div>
              <div class="b">手机激活当天上高速</div>

            </div>
            <div class="r">
              <img lazy-load src="https://wecos.etczs.net/pages/truck/five-star.png" />
              <div class="b">99%司机给出5星好评</div>

            </div>
          </div>
          <div class="advantage-introduce">
            <div class="item">
              包邮寄送
            </div>
            <div class="item">
              2年质保
            </div>
            <div class="item">
              专属客服
            </div>
          </div>
          <div class="popup-tap" @click="showWorkflow">
            <div >查看详细步骤</div>
            <img lazy-load class="arrow" src="https://wecos.etczs.net/assets/images/arrow-down-1230.png" />
          </div>
        </div>
        <div class="truck-type truck-item">
          <div class="truck-field-title-flex ">
            <div class="l">
              <div class="t">微信自动扣款</div>
              <div class="b">查账开票一步搞定</div>

            </div>
            <div class="r">
              <img lazy-load src="https://wecos.etczs.net/pages/truck/five-praise.png" />
              <div class="b">99%司机为出账速度点赞</div>

            </div>
          </div>
          <div class="step-table">
            <div class="table-field t">
              <div class="th-t-l">账期</div>
              <div class="th">出账日</div>
              <div class="th">还款日</div>
              <div class="th">还款方式</div>
            </div>
            <div class="table-field">
              <div class="th">日结卡</div>
              <div class="td">通行后1-3日</div>
              <div class="td">次日</div>
              <div class="td">微信支付</div>
            </div>
            <div class="table-field">
              <div class="th">周结卡</div>
              <div class="td">通行后1-3日</div>
              <div class="td">每周一</div>
              <div class="td">微信支付</div>
            </div>
          </div>
        </div>
        <div class="equity truck-item">
          <div class="truck-field-title-flex ">
            <div class="l">
              <div class="t">ETC助手办理</div>
              <div class="b">产品服务全国领先</div>

            </div>
            <div class="r">
              <img lazy-load src="https://wecos.etczs.net/pages/truck/five-ok.png" />
              <div class="b">全心全意为货车司机服务</div>

            </div>
          </div>
          <div class="equity-list">
            <img lazy-load src="https://wecos.etczs.net/pages/truck/h5-truck-equity.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="truck-qa truck-item">
      <div class="truck-field-title" >
        <img class="icon-l icon" src="https://wecos.etczs.net/pages/truck/truckDetail-A-title-icon.png" />
        <span class="truck-field-title-text">常见问题</span>
        <img class="icon-r icon" src="https://wecos.etczs.net/pages/truck/truckDetail-A-title-icon.png" />
      </div>
      <div class="qa-filed" v-for="(item, i) in qaList" :key="i+ 'qa'">
        <div class="t">{{ item.question }}</div>
        <div class="b">
          <div class="c">{{ item.answer }}</div>
        </div>
      </div>
    </div>
    <div class="fixed-btn" v-if="showApplyBtn" >
      <button class="apply-btn" type="light" @click="buttonHandler" >
        办理货车ETC
        <img class="truck-btn-tip" lazy-load mode="widthFix" src="https://wecos.etczs.net/pages/truck/truck-btn-tip.png" />
      </button>
      <div class="car-entry" @click="navigateToPage">
        <img class="icon" src="https://wecos.etczs.net/newIndex/etc-car.png" />
        <span class="text">前往办理乘用车ETC</span>
        <img class="icon-right" src="https://wecos.etczs.net/apply/icon-right.png" />
      </div>
    </div>

    <div v-if="workflowShow"  class="workflow" @mousewheel.prevent>
     <div class="workflow-mask" :class="{ 'show': showAnimate }" @click="closeToast"></div>
      <div class="workflow-container" :class="{ 'show': showAnimate }" >
        <div class="close-btn" @click="closeToast">
          <img src="https://wecos.etczs.net/h5/truck/truck-logo-close.png" />
        </div>
        <div class="workflow-title">
          <div class="t">详细步骤</div>
        </div>
        <div class="apply-step-container">
          <div class="dashe-line"></div>
          <div class="apply-step-item no-wrap" v-for="(item, i) in applyStepTruck" :key="'step' + i" >
            <img class="item-img" :src="item.img" />
            <div class="item-label">
              <div class="t">{{ item.t }}</div>
              <div class="label-tag" v-if="item.tag">{{ item.tag }}</div>
            </div>
            <div class="item-value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// import ChannelMixin from '@/mixins/channelMixin'
import BiMixin from '@/mixins/biMixin'

import Util from '@/utils/util'

import { TRUCK_QA_LIST, TRUCK_EVALUATE_LIST, TRUCK_APPLY_LIST, APPLY_STEP_TRUCK } from '@/config/etc.config'
const logoBaseSrc = 'https://wecos.etczs.net/h5/truck/'
const CHANNEL_PARAMS = {
  'lmfx': {
    logo: logoBaseSrc + 'lmfx-logo.png',
    pl: 1078,
    entry: 2147,
    truckScheme: 'https://modalh5.etczs.net/scheme?p=pages%2Ftruck%2Fpage%2FtruckDetail%3Fscene%3D%2524%2524_1078_mtMQTd%2524c%253F%2524_11100328',
    showCarBtn: false,
    name: '流马风行'
  },
  // 普洛斯线上
  'pls': {
    logo: logoBaseSrc + 'pls-logo.png',
    pl: 1077,
    entry: 2146,
    truckScheme: 'https://modalh5.etczs.net/scheme?p=pages%2Ftruck%2Fpage%2FtruckDetail%3Fscene%3D%2524%2524_1077_mtPG3%253DQaw0_11100329',
    carPl: 1110,
    carEntry: 2179,
    carScheme: 'https://modalh5.etczs.net/scheme?p=pages%2FnewApply%2Fpage%2FgoodsPayChild%3Fscene%3D%2524%2524_768_mwUnYEGl%253AM_11100331',
    showCarBtn: true,
    name: '普洛斯线上'

  },
  // 普洛斯地推
  'pls_dt': {
    logo: logoBaseSrc + 'pls-logo.png',
    pl: 536,
    entry: 1606,
    truckScheme: 'https://modalh5.etczs.net/scheme?p=pages%2Ftruck%2Fpage%2FtruckDetail%3Fscene%3D%2524%2524_536_mFWw5nSTg0_11100338',
    carPl: 1110,
    carEntry: 2179,
    carScheme: 'https://modalh5.etczs.net/scheme?p=pages%2FnewApply%2Fpage%2FgoodsPayChild%3Fscene%3D%2524%2524_768_mwUnYEGl%253AM_11100331',

    showCarBtn: true,
    name: '普洛斯地推'

  },
  'lt': {
    logo: logoBaseSrc + 'lt-logo.png',
    pl: 1111,
    entry: 2180,
    truckScheme: 'https://modalh5.etczs.net/scheme?p=pages%2Ftruck%2Fpage%2FsubmitAddress%3Fpl%3D1111%26entry%3D2180',
    carPl: 1111,
    carEntry: 2187,
    carScheme: 'https://modalh5.etczs.net/scheme?p=pages%2FnewApply%2Fpage%2FsubmitAddress%3Fpl%3D1111%26entry%3D2187',
    showCarBtn: true,
    name: '联通'
  }
}
export default {
  name: 'truckDetail',
  mixins: [FunMixin, BiMixin],
  components: {
  },
  directives: {
  },
  data() {
    return {
      showApplyBtn: false,
      qaList: TRUCK_QA_LIST,
      evaluateList: TRUCK_EVALUATE_LIST,
      evaluateIndex: 0,
      evaluateTimer: 0,
      currentEvaluate: TRUCK_EVALUATE_LIST[0],
      applyUserList: TRUCK_APPLY_LIST,
      applyIndex: 0,
      applyTimer: 0,
      currentApply: TRUCK_APPLY_LIST[0],
      isIphoneX: true,
      truckChannelData: {
        name: '',
        logo: '',
        pl: 1000,
        entry: 1000,
        truckScheme: '',
        carScheme: 'https://modalh5.etczs.net/scheme?p=pages%2FnewApply%2Fpage%2FsubmitAddress',
        showCarBtn: true
      },
      applyStepTruck: APPLY_STEP_TRUCK,
      workflowShow: false,
      showAnimate: false
    }
  },

  computed: {
  },
  methods: {
    // 关闭弹窗
    closeToast(isClose = true) {
      this.showAnimate = false
      setTimeout(() => {
        this.workflowShow = false
      }, 300)
    },
    // 打开/关闭弹窗
    showWorkflow() {
      if (this.workflowShow) {
        this.showAnimate = false
        setTimeout(() => {
          this.workflowShow = false
        }, 300)
      } else {
        this.workflowShow = true
        setTimeout(() => {
          this.showAnimate = true
        }, 10)
      }
    },
    navigateToPage() {
      location.href = this.truckChannelData.carScheme
      this.biLog({
        region: this.truckChannelData.name + '-货车H5引导页',
        obj_name: '前往办理乘用车ETC'
      })
    },
    buttonHandler() {
      location.href = this.truckChannelData.truckScheme
      this.biLog({
        region: this.truckChannelData.name + '-货车H5引导页',
        obj_name: '货车ETC办理'
      })
    },
    startEvaluateMove () {
      // eslint-disable-next-line
      this.evaluateTimer = setTimeout(() => {
        if (this.evaluateIndex === this.evaluateList.length - 1) {
          this.evaluateIndex = 0
        } else {
          this.evaluateIndex += 1
        }
        this.currentEvaluate = TRUCK_EVALUATE_LIST[this.evaluateIndex]
        this.startEvaluateMove()
      }, 5000) // 滚动不需要停顿则将2000改成动画持续时间
    },
    startApplyMove () {
      // eslint-disable-next-line
      this.applyTimer = setTimeout(() => {
        if (this.applyIndex === this.evaluateList.length - 1) {
          this.applyIndex = 0
        } else {
          this.applyIndex += 1
        }
        this.currentApply = TRUCK_APPLY_LIST[this.applyIndex]
        this.startApplyMove()
      }, 5000) // 滚动不需要停顿则将2000改成动画持续时间
    },
    // 滚动事件
    scrollToTop() {
      this.showApplyBtn = Util.isElementNotInViewport(this.$refs.allBtn)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
    console.log(this.$route.query);
    const truckChannel = this.$route.query.truckChannel
    if (truckChannel && CHANNEL_PARAMS[truckChannel]) this.truckChannelData = CHANNEL_PARAMS[truckChannel]
  },
  beforeDestroy () {
    clearTimeout(this.evaluateTimer)
    clearTimeout(this.applyTimer)
  },
  beforeRouteLeave(to, form, next) {
    // 离开路由移除滚动事件
    window.removeEventListener('scroll', this.scrollToTop);
    next();
  },
  created() {
    this.startEvaluateMove()
    this.startApplyMove()
  }
}
</script>

<style scoped lang="scss">

.new-index {
  background: #e5f8f2;
  padding-bottom: 214px !important;

  &.iphoneX {
    padding-bottom: 282px !important;
  }
  &.hide-car-btn {
    padding-bottom: 130px  !important;
    &.iphoneX {
    padding-bottom: 198px !important;
    }
    .car-entry {
      display: none !important;
    }
  }

 .truck-field-title-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 28px;
    .l {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 54px;
      .t {
        font-size: 36px;
      }
      .b {
        font-size: 28px;
      }
    }
    .r {
      img {
        width: 220px;
        height: 50px;
        display: block;
        margin-bottom: 8px;
      }
      .b {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 36px;
      }
    }
  }

  .truck-field-title {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
    .icon {
      width: 40px;
      height: 24px;
      &-r {
        transform: rotate(180deg);
      }
    }
  }

  .truck-field-title-text {
    margin: 0 20px;
    display: block;
    font-size: 36px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #16c88b;
    line-height: 54px;
  }

  .truck-item {
    width: 710px;
    margin: 20px auto 0;
    background-color: #fff;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 40px;

    .truck-field-title {
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #16c88b;
      line-height: 54px;
    }
  }
  // 常见问题
  .truck-qa {
    .qa-filed {
      padding: 40px 0;
      border-bottom: 1px solid #ddd;

      &:last-child {
        border: none;
      }
      .t {
        display: flex;
        align-items: center;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 45px;

        &::before {
          margin-right: 20px;
          content: 'Q';
          line-height: 32px;
          text-align: center;
          display: block;
          font-size: 16px;
          width: 32px;
          height: 32px;
          color: #fff;
          background-color: #16c88b;
          border-radius: 50% 50% 50% 0;
        }
      }

      .b {
        display: flex;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 40px;
        margin-top: 12px;

        .c {
          width: 578px;
        }

        &::before {
          margin-top: 6.5px;
          margin-right: 20px;
          content: 'A';
          line-height: 32px;
          text-align: center;
          display: block;
          font-size: 16px;
          width: 32px;
          height: 32px;
          color: #fff;
          background-color: #eeb73f;
          border-radius: 50% 0 50% 50%;
        }
      }
    }
  }

    .page-b {
      .top-notice-box-fff {
        position: relative !important;
        margin-top: 20px !important;
        z-index: 1;
        width: 710px;
        margin: 0 auto;
        background: transparent;
        padding-bottom: 24px;
        .top-notice-box {
          width: 710px;
          box-sizing: border-box;

          border-radius: 16px;
          background-color: #fff;
          padding: 0 20px;
          border-radius: 16px;
        }
      }
    }
    .privilege {
      margin: 28px auto 0;
      width: 654px;
      height: 184px;
      box-sizing: border-box;
      padding: 20px;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('https://wecos.etczs.net/pages/truck/truckDetail-privilege-bg.png');
      .li {
        display: flex;
        font-size: 28px;
        color: #A06D3D;
        line-height: 48px;
      }
      .num {
        font-size: 32px;
        font-family: 'Roboto-BoldItalic';

        font-weight: normal;
      }
      .label {
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      .value {
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    .apply-btn {
      margin: 48px auto 0;

      font-size: 36px;
      overflow: visible;
      position: relative;
      width: 640px;
      height: 90px;
      background: linear-gradient(180deg, #0DE2A4 0%, #15C3C3 100%);
      box-shadow: 0px 6px 12px 0px rgba(12, 161, 147, 0.35);
      border-radius: 75px;
      color: #fff;

    }

    .apply-tag {
      position: absolute;
      width: 88px;
      height: 62px;
      top: -5px;
      right: 55px;
    }
  .truck-btn-tip {
    position: absolute;
    width: 94px;
    height: 62px;
    top: -8px;
    right: 79px;
  }
  .car-entry {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 42px;
    margin-top: 30px;
    .icon {
      display: block;
      width: 40px;
      height: 40px;
      margin-right: 20px;
      vertical-align: middle;
    }
    .text {
      height: 42px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 42px;
    }
    .icon-right {
      width: 24px;
      height: 24px;
      margin-left: 4px;
    }
  }

  .fixed-btn {
    position: fixed;
    width: 100%;
    bottom: 0px;
    left: 0;
    padding: 32px 0;
    background-color: #fff;

    .apply-btn {
      margin: 0 auto 0;
      margin-left: 55px;
    }
  }
}

.detail-B {
  overflow: hidden;
  .header {
    overflow: hidden;
    .header-banner {
      position: relative;
      overflow: hidden;
      .channel-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0;
        top: 33px;
        position: absolute;
        width: 100%;
        z-index: 2;
        .close {
          margin-left: 16px;
          margin-right: 16px;
          width: 24px;
          height: 24px;
        }
        .flex-1 {
          flex: 1;
        }
        .l {
          text-align: right;
          img {
            width: 100px;
            height: 52px;
          }
        }
        .r {
          text-align: left;
          img {
            width: 60px;
            height: 60px;
          }
        }
      }
      &.long-screen {
        .header-img {
          top: 0;
        }
      }
      .header-img {
        width: 750px;
        display: block;
        position: absolute;
        // top: -48px;
        left: 0;
      }
    }
  }

  .header-tip {
    margin-top: 422px;
    min-height: 68px;
    .swiper {
      font-size: 24px;
      height: 48px;
      width: 700px;
      text-align: center;
      line-height: 48px;
      color: #fff;
      margin-bottom: 20px;
      position: relative;
      overflow: hidden;
      padding: 0 10px 0 20px;
      .item-box {
        display: flex;
        position: absolute;
        border-radius: 24px;
        box-sizing: border-box;
        padding: 0 16px 0 6px;
        background: rgba(0, 0, 0, 0.4);
        align-items: center;
        box-sizing: border-box;
      }
      .item {
        padding-left: 12px;
      }
      .swipe-img {
        display: block;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: #d8d8d8;
        overflow: hidden;
        img {
          width: 36px;
          height: 36px;
        }
      }
    }
    .apply-enter-active,
    .apply-leave-active {
      transition: all 0.5s linear;
    }
    .apply-enter {
      transform: translateY(48px) scale(1);
      opacity: 1;
    }
    .apply-leave-to {
      transform: translateY(-48px) scale(0.8);
      opacity: 0;
    }
  }
  .long-screen {
    .header-tip {
      margin-top: 460px;
    }
  }
  .btns-con {
    box-sizing: border-box;
    background-color: #fff;
    margin: 0 auto;
    padding: 28px 28px 28px;

    width: 710px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    position: relative;
    z-index: 2;
    .etc-introduce {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .introduce-l {
        .title {
          display: flex;
          align-items: center;
          .name {
            font-size: 40px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 60px;
          }
          .logo {
            margin-left: 16px;
            width: 151px;
            height: 44px;
            background: #ffea6a;
            border-radius: 22px;
            display: flex;
            align-items: center;

            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #a06d3d;
            line-height: 33px;
            .logo-img {
              width: 32px;
              height: 32px;
              display: block;
              margin-right: 3px;
              margin-left: 8px;
            }
          }
        }
        .tip {
          margin-top: 13px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 42px;
          span {
            color: #f8b10c;
          }
        }
      }
      .introduce-r {
        img {
          height: 92px;
          width: 181px;
          display: block;

        }
        .text {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 36px;
          text-align: center;
          margin-top: 10px;
        }
      }
    }
  }
  .evaluate {
    width: 710px;
    box-sizing: border-box;
    padding: 24px 28px !important;

    .title {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #cccccc;
      line-height: 40px;
    }
    .evaluate-list {
      height: 140px;
      margin-top: 16px;
      overflow: hidden;
      position: relative;
    }
    .evaluate-item {
      display: flex;
      height: 140px;

      z-index: 20;
      width: 100%;
      position: absolute;
      bottom: 0;

      .evaluate-item-l {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 22px;
      }
      .evaluate-item-r {
        width: 587px;
        height: 124px;
        background: #f5f6f7;
        border-radius: 8px;
        position: relative;
        box-sizing: border-box;
        padding: 10px 19px;
        &::before {
          display: block;
          content: '';
          width: 16px;
          height: 16px;
          background: #f5f6f7;
          position: absolute;
          top: 16px;
          left: -6px;
          transform: rotate(45deg);
        }
        .name {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 33px;
        }
        .value {
          margin-top: 3px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
        }
      }
    }
  }
  .evaluate-enter-active,
  .evaluate-leave-active {
    transition: all 0.5s linear;
  }
  .evaluate-enter {
    transform: translateY(140px) scale(1);
    opacity: 1;
  }
  .evaluate-leave-to {
    transform: translateY(-140px) scale(0.8);
    opacity: 0;
  }
  .equity {
    padding-left: 28px !important;
    padding-right: 28px !important;
    padding-bottom: 18px;
    .equity-list {
      margin-top: 14px;
      img {
        width: 662px;
        height: 1098px;
        text-align: center;
        font-size: 0;
        margin-left: -16px;
      }
    }
    .popup-tap {
      width: 440px;
    }
  }
  .popup-tap {
    margin: 40px auto 0;
    display: flex;
    align-items: center;
    width: 300px;
    height: 64px;
    box-sizing: border-box;
    padding-left: 54px;
    background: #f5f6f7;
    border-radius: 34px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 64px;
    .arrow {
      margin-left: 4px;
      width: 28px;
      height: 28px;
      transform: rotate(-90deg);
    }
  }
  .advantage {
    padding: 40px 0px 39px;

    .advantage-introduce {
      display: flex;
      justify-content: space-between;
      margin-top: 47px;
      padding: 0 28px;
      .item {
        width: 205px;
        height: 180px;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('https://wecos.etczs.net/pages/truck/advantage-new-02.png');
        &:first-child {
          background-image: url('https://wecos.etczs.net/pages/truck/advantage-new-01.png');
        }
        &:last-child {
          background-image: url('https://wecos.etczs.net/pages/truck/advantage-new-03.png');
        }
        box-sizing: border-box;
        padding-top: 121px;
        text-align: center;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
        text-shadow: 0px 1px 3px rgba(64, 69, 79, 0.5);
      }
    }

  }

  .truck-type {
    padding-left: 0 !important;
    padding-right: 0 !important;

    .step-table {
      overflow: hidden;
      width: 670px;
      border-radius: 16px;
      margin: 40px auto 0;

      .table-field {
        display: flex;
        justify-content: center;

        div {
          width: 184px;
          height: 98px;
          margin: 2px;
          line-height: 98px;
          text-align: center;
        }

        .th-t-l {
          background-color: #fce8b2;
        }

        .th {
          background: #efefef;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }

        .td {
          background-color: #f7f7f7;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        &.t {
          div {
            margin-top: 0;
          }
        }

        div:first-child {
          margin-left: 0;
        }

        div:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .certificate {
    .certificate-content {
      margin-top: 34px;
      display: flex;
      padding-left: 2px;

      img {
        display: block;
        width: 180px;
        height: 120px;
        margin-bottom: 14px;
      }

      .field-name {
        text-align: center;

        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;

        &-tip {
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 40px;
        }
      }

      .l {
        margin-right: 43px;
      }

      .c {
        margin-right: 24px;
      }

      .r {
        img {
          display: block;
          width: 220px;
        }
      }
    }
  }

  .after-sale {
    .after-sale-content {
      margin-top: 29px;
      display: flex;
      justify-content: center;
      align-items: center;

      .line {
        width: 1px;
        height: 81px;
        background: #e8e8e8;
        margin-left: 36px;
        margin-right: 21px;
      }

      .certificate-field {
        display: flex;

        img {
          width: 100px;
          height: 120px;
          display: block;
          margin-right: 7px;
        }

        .field-text {
          padding-top: 14px;

          .title {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 48px;
          }

          .con {
            margin-top: 4px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 42px;
          }
        }
      }
    }
  }
  .discount {
    padding-left: 0 !important;
    padding-right: 0 !important;
    .discount-table {
      margin: 40px auto 8px;
      width: 670px;
      // height: 420px;
      border-radius: 4px;
      border: 1px solid #ddd;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      display: flex;

      .table-item {
        overflow: hidden;
        div:nth-child(even) {
          background: #f7f7f7;
        }

        div {
          height: 80px;
          line-height: 80px;
          box-sizing: border-box;

          &.table-title {
            line-height: 100px;
            display: flex;
            align-items: center;

            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;

            img {
              width: 32px;
              height: 32px;
              margin-right: 8px;
              display: block;
            }
          }
        }

        &.l {
          width: 172px;
          border-right: 1px solid #ddd;

          .height {
            height: 160px;

            line-height: 160px;
          }
          div {
            padding-left: 58px;

            &.table-title {
              padding-left: 34px;
            }
          }
        }

        &.r {
          // width: 229px;
          flex: 1;
          .height {
            height: 160px;
            line-height: 48px;
            padding: 8px 20px 8px 42px;
          }
          div {
            padding-left: 42px;
            .yellow {
              color: #F8B10C;
            }
            &.table-title {
              padding-left: 53px;
            }
          }
        }
      }
    }
    .tip {
      font-size: 40px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 28px;
      margin-left: 46px;
      margin-top: 28px;
      text-align: center;
      white-space: nowrap;
      transform: scale(0.5);
      transform-origin: left top;
    }
  }
}
.workflow {
  width:100%;
  height:100%;
  position: fixed;
  z-index: 30;
  top:0;
  left:0;
  overflow: hidden;
  .workflow-mask {
    position: fixed;
    z-index: 21;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    transition: opacity 0.3s;
    opacity: 0;
    &.show {
      opacity: 0.5;
    }
  }
.workflow-container {
    position: absolute;
    width: 750px;
    background-color: #fff;
    border-radius: 32px 32px 0 0;
    z-index: 22;
    width: 100%;
    box-sizing: border-box;
    padding: 40px;
    left: 0;
    bottom: 0;
    transition: transform 0.3s;
    transform: translateY(100%);
    &.show {
      transform: translateY(0);
    }
    .close-btn {
      position: absolute;
      left: 40px;
      top: 40px;
      width: 48px;
      height: 48px;
      img {
        display: block;
        width: 48px;
        height: 48px;
      }
    }
    .workflow-title {
      margin-left: -40px;
      line-height: 50px;
      font-size: 36px;
      font-weight: 500;
      padding-bottom: 52px;
      text-align: center;
    }
    .apply-step-container {
      position: relative;
      .dashe-line {
        position: absolute;
        left: 24px;
        top: 0;
        height: 100%;
        border-left: 4px dotted #E8E8E8;
      }
      .apply-step-item {
        position: relative;
        padding-left: 76px;
        padding-right: 40px;
        // overflow: hidden;
        &:last-of-type::after {
          content: '';
          position: absolute;
          z-index: 2;
          top: 67px;
          left: 20px;
          background-color: #fff;
          height: 100%;
          width: 26px;
        }
        &.no-wrap {
          padding-right: 32px;
        }
        .item-img {
          position: absolute;
          left: 0px;
          top: 0px;
          width: 56px;
          height: 56px;
          background-color: #fff;
        }
        .item-label {
          line-height: 56px;
          font-size: 32px;
          font-weight: 500;
          color: #333;
          display: flex;
          align-items: center;
          .label-tag {
            font-weight: normal;
            margin-left: 20px;
            line-height: 40px;
            border-radius: 20px;
            padding: 0 16px;
            color: #16C88B;
            background:rgba(22,200,139,0.07);
            font-size: 24px;
          }
        }
        .item-value {
          padding-top: 12px;
          box-sizing: border-box;
          min-height: 118px;
          line-height: 42px;
          font-size: 28px;
          color: #666;
          &.no-bottom {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
